import { Component, HostListener, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { DialogService } from '../../services/shared/dialog/dialog.service';
import { TranslationService } from '../../services/translation/translation.service';
import { PageConfigComponent } from '../../features/admin/pages/page-config/page-config.component';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { CacheService } from '../../services/cache/cache.service';
import { SnackbarService } from '../../services/shared/snackbar/snackbar.service';
import { LoadingService } from '../../services/loading/loading.service';
import { ExportService } from '../../services/export/export.service';
import { VersionService } from '../../services/version/version.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css'
})
export class AdminLayoutComponent {
  @ViewChild(RouterOutlet) outlet!: RouterOutlet;
  currentRoute: string = '';
  version: string = '';
  isLoading = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private dialogService: DialogService,
    private translationService: TranslationService,
    private cacheService: CacheService,
    private snackBar: SnackbarService,
    private loadingService: LoadingService,
    private exportService: ExportService,
    private versionService: VersionService) {
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });

    this.loadingService.loading$.subscribe(state => {
      this.isLoading = state;
    });
  }
  ngOnInit() {
    this.GetVersionFromFile();
  }

  confirmNavigation(link: string): void {
    const activeComponent = this.outlet.component;
    if (activeComponent instanceof PageConfigComponent && activeComponent.isEdited) {
      this.dialogService.confirm(this.translationService.translate('Pending save'),this.translationService.translate('You have unsaved changes. Are you sure you want to leave?')).then((confirmed) => {
        if (confirmed) {
          if(link == "logout")
          {
            this.logout();
          }
          else{
            this.router.navigate([link]);
          }
        }
      });
    }
    else{
      if(link == "logout")
      {
        this.logout();
      }
      else{
        this.router.navigate([link]);
      }

    }
  }

  logout(): void {
    this.authService.logout();
  }

  isActive(link: string): boolean {
    return this.currentRoute === link;
  }

  GetVersionFromFile() {
    var version = this.versionService.get();
    if (version != 'local') {
      this.version = "Version: " + this.versionService.get();
    }
    else {
      this.version = this.versionService.get();
    }
  }

  clearCache(): void {
    this.cacheService.clearCache()
    .subscribe({
      next: (result: boolean) => {
        if(result)
        {
          this.snackBar.showSuccess(this.translationService.translate('Success on cleaning cache'));
        }
        else{
          this.snackBar.showError(this.translationService.translate('Error on cleaning cache'));
        }
      },
      error: (error) => {
        this.snackBar.showError(this.translationService.translate('Error on cleaning cache'));
      }
    });
  }

  @HostListener('click', ['$event'])
  onEditorClick(event: MouseEvent) {
    document.execCommand('styleWithCSS', false, 'true');
  }
}

